import videojs from 'video.js';
import attachSvg from '../templates/attach.svg.html';

const Component = videojs.getComponent('Component');

class ButtonAttach extends Component {
	constructor(player, options) {
		super(player, options);

		this._options = options;

		this.addChangeListener();
	}

	createEl() {
		const label = videojs.dom.createEl('label', {
			className: 'vjs-chat-form-body__attach',
			innerHTML: attachSvg()
		});
		const input = videojs.dom.createEl('input', {
			type: "file",
			accept: this.options_.allowedFileTypes,
			multiple: true
		});

		this.inputEl_ = input;

		videojs.dom.appendContent(label, [input]);

		return label;
	}

	addChangeListener() {
		const handleChange = (event) => {
			for (let i = 0; i < event.target.files.length; i++) {
				const file = event.target.files[i];

				const isValidFileType = this._options.allowedFileTypes.includes(file.type);
				const isValidFileSize = file.size < this._options.maxFileSize;

				if (!isValidFileType) {
					this._options.handleFileTypeError();
					return;
				}

				if (!isValidFileSize) {
					this._options.handleFileSizeError();
					return;
				}
			}

			this._options.handleSuccess(event.target.files);
		};

		this.inputEl_.addEventListener('change', handleChange);

		this.on('dispose', () => {
			this.inputEl_.removeEventListener('change', handleChange);
		});
	}
}

export { ButtonAttach };
